/**
 *
 * Factoid
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _isUndefined from 'lodash/isUndefined';
import { withStyles } from '@material-ui/core/styles';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import FactoidCard from 'components/FactoidCard';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { getSources } from 'containers/Sources/actions';
import { makeSelectFactoid } from 'containers/Sources/selectors';

const styles = () => ({
  root: {
    marginTop: 25,
  },
});

/* eslint-disable react/prefer-stateless-function */
export class Factoid extends React.PureComponent {
  state = {
    factoidIndex: undefined,
  };

  componentDidMount() {
    const topicIds = this.props.data.map(({ sys }) => sys.id).join(',');
    this.props.getSources({
      type: 'Factoid',
      topicId: topicIds,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.factoid !== nextProps.factoid &&
      !_isEmpty(_get(nextProps.factoid, 'items'))
    ) {
      if (_isUndefined(this.state.factoidIndex)) {
        this.setState({
          factoidIndex: Math.floor(
            Math.random() * nextProps.factoid.items.length,
          ),
        });
      }
    }
  }

  render() {
    const { classes, factoid, topicName } = this.props;
    const { factoidIndex } = this.state;
    if (_isEmpty(_get(factoid, 'items')) && _isUndefined(factoidIndex))
      return null;
    return (
      <div className={classes.root}>
        <FactoidCard data={factoid.items[factoidIndex]} topicName={topicName} />
      </div>
    );
  }
}

Factoid.propTypes = {
  factoid: PropTypes.object,
  classes: PropTypes.object,
  data: PropTypes.object,
  getSources: PropTypes.func,
  topicName: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  factoid: makeSelectFactoid(),
});

function mapDispatchToProps(dispatch) {
  return {
    getSources: payload => dispatch(getSources(payload)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withStyles(styles),
  withConnect,
)(Factoid);
